import React from 'react'
import './slideShow.scss'
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from 'react-router-dom';



const SlideShow = () => {
    const options = {
      loop: true,
      responsiveClass: true,
      center: true,
      items: 1,
      margin: 0,
      autoplay: true,
      dots: true,
      autoplayTimeout: 8500,
      smartSpeed: 450,
      nav: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    };


  return (
    <div className="">
      <Link to={"/offers"}>
        <div className="slideShow ">
          <OwlCarousel className="owl-theme" {...options}>
            <div class="item">
              <img src={require("../../img/hero_img/04.jpg")} />
              <div className="slideText">
                <h1>Crafted for Wholesale Excellence</h1>
                <p>
                  Consistent quality, scalable supply, and private-label
                  solutions
                </p>
              </div>
            </div>
            <div class="item">
              <img src={require("../../img/hero_img/01.jpg")} />
              <div className="slideText">
                <h1>Where Luxury Chocolate Meets Business Excellence</h1>
                <p>
                  Premium handcrafted chocolates for hotels, corporates &
                  exclusive retailers
                </p>
              </div>
            </div>
            <div class="item">
              <img src={require("../../img/hero_img/02.jpg")} />
              <div className="slideText">
                <h1>Elevate Corporate Gifting</h1>
                <p>
                  Bespoke chocolate collections designed for premium brands and
                  executive gifting
                </p>
              </div>
            </div>
            <div class="item">
              <img src={require("../../img/hero_img/03.jpg")} />
              <div className="slideText">
                <h1>Designed for the World’s Finest Hospitality</h1>
                <p>
                  Trusted by luxury hotels, airlines & high-end hospitality
                  partners
                </p>
              </div>
            </div>

            <div class="item">
              <img src={require("../../img/hero_img/05.jpg")} />
              <div className="slideText">
                <h1>Artisan Craftsmanship. Exceptional Ingredients.</h1>
                <p>
                  Ethically sourced cocoa, refined flavors, and uncompromising
                  standards
                </p>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </Link>
    </div>
  );
}

export default SlideShow
